import {useAuth} from '../../../../../app/modules/auth'
import {AdminMenu} from './AdminMenu'
import {LecturerMenu} from './LecturerMenu'
import {ParentMenu} from './ParentMenu'
import {StudentMenu} from './StudentMenu'

export function MenuInner() {
  const {currentUser} = useAuth()
  const pos = currentUser?.position
  return (
    <>
      {pos !== 'Lecturer' && pos !== 'Student' && pos !== 'Parent' && <AdminMenu />}
      {pos === 'Lecturer' && <LecturerMenu />}
      {pos === 'Student' && <StudentMenu />}
      {pos === 'Parent' && <ParentMenu />}
    </>
  )
}
